import { IconButton, Paper, Popper, TextField } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import { ArrowDropDown as ArrowDropDownIcon, Close as CloseIcon, } from "@material-ui/icons";
import { useAutocomplete, } from "@material-ui/lab";
import clsx from "clsx";
import debounce from "lodash/debounce";
import React, { useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useStyles } from "./useStyles";
const debouncedInput = debounce((input, setInputValueFn) => setInputValueFn(input), 500);
const defaultGetOptionSelected = (option, selectedValue) => option.value === selectedValue.value;
export default function AutocompleteInfiniteScroll({ options, fetchNext, loading, onChange, onInputChange, placeholder, value, hasMore, freeSolo, disableClearable, disabled, forcePopupIcon, closeText, openText, required, helperText, error, className, getOptionSelected, open, }) {
    const handleInputChange = (input, reason) => {
        if (reason === "reset")
            return null;
        return debouncedInput(input, onInputChange);
    };
    const classes = useStyles();
    const { getRootProps, getInputLabelProps, getInputProps, getListboxProps, inputValue, popupOpen, getOptionProps, getClearProps, anchorEl, setAnchorEl, dirty, focused, getPopupIndicatorProps, } = useAutocomplete({
        componentName: "Autocomplete",
        options,
        getOptionSelected: getOptionSelected || defaultGetOptionSelected,
        getOptionLabel: (option) => option.label,
        onChange: (_, newValue) => {
            onChange(newValue);
        },
        onInputChange: (_, newValue, reason) => {
            handleInputChange(newValue, reason);
        },
        value,
        open,
    });
    const [randomId] = useState((Math.random() + 1).toString(36).slice(7));
    const hasClearIcon = !disableClearable && !disabled;
    const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    return (React.createElement("div", { ...getRootProps(), className: clsx(classes.root, classes.fullWidth, {
            [classes.focused]: focused,
            [classes.hasClearIcon]: hasClearIcon,
            [classes.hasPopupIcon]: hasPopupIcon,
        }, className) },
        React.createElement("div", { className: classes.inputRoot, ...getRootProps() },
            React.createElement(TextField, { ref: setAnchorEl, className: classes.inputRoot, disabled: disabled, InputLabelProps: getInputLabelProps(), value: inputValue, fullWidth: true, label: placeholder, required: required, helperText: helperText, error: error, variant: "outlined", InputProps: {
                    endAdornment: (React.createElement("div", { className: classes.endAdornment },
                        loading ? (React.createElement("div", { className: classes.loadingIndicator },
                            React.createElement(CircularProgress, { className: classes.loadingIndicator, color: "inherit", size: 20 }))) : null,
                        hasClearIcon ? (React.createElement(IconButton, { ...getClearProps(), className: clsx(classes.clearIndicator, {
                                [classes.clearIndicatorDirty]: dirty,
                            }) },
                            React.createElement(CloseIcon, { fontSize: "small" }))) : null,
                        hasPopupIcon ? (React.createElement(IconButton, { ...getPopupIndicatorProps(), disabled: disabled, "aria-label": popupOpen ? closeText : openText, title: popupOpen ? closeText : openText, className: clsx(classes.popupIndicator, {
                                [classes.popupIndicatorOpen]: popupOpen,
                            }) },
                            React.createElement(ArrowDropDownIcon, null))) : null)),
                    inputProps: {
                        disabled,
                        ...getInputProps(),
                    },
                } })),
        anchorEl && popupOpen ? (React.createElement(Popper, { anchorEl: anchorEl, style: { width: anchorEl ? anchorEl.clientWidth : "inherit" }, open: popupOpen, className: classes.popper },
            React.createElement(Paper, { className: classes.paper },
                React.createElement("ul", { className: classes.listbox, role: "listbox", ...getListboxProps(), id: randomId },
                    React.createElement(InfiniteScroll, { dataLength: options.length, next: fetchNext, hasMore: hasMore, loader: React.createElement("li", { className: classes.option }, "Loading..."), scrollableTarget: randomId },
                        options.map((option, index) => (React.createElement("li", { ...getOptionProps({ option, index }), className: classes.option }, option.label))),
                        loading ? (React.createElement("li", { className: clsx(classes.option, classes.loader) }, "Loading...")) : null))))) : null));
}
//# sourceMappingURL=index.js.map